import { styled } from '@mui/material';
import Slider from 'react-slick';

// MainContentStyles.js
export const Container = styled('div')`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 1.5vw 5vw;
  margin: 0 auto;
  gap: 5vw;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0vw;
    padding: 3vw 5vw;
  }
`;

export const LeftSection = styled('div')`
  width: 40%;
  margin-top: 2vw;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const RightSection = styled('div')`
  width: 60%;
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    width: 100%;
  }
  img {
    height: auto;
    object-fit: contain;
    max-width: 100%; 
  }
`;

export const Title = styled('span')`
  font-size: 3.188rem; //51px
  font-weight: bold;
  color: #85858E;
  margin-bottom: 5vw;
  @media (max-width: 1280px) {
    font-size: 2.8rem; 
  }
  @media (max-width: 768px) {
    font-size: 2.4rem; 
  }
  @media (max-width: 480px) {
    font-size: 2rem; 
  }
  @media (max-width: 375px) {
    font-size: 1.894rem; //30.3px

  }
`;

export const Text = styled('p')`
  font-size: 1.313rem; // 21px 
  color: #231F20;
  font-weight: 400;
  line-height: 33px; /* 157.143% */
  font-family: Radikal;
  margin-top: 1rem;

  @media (max-width: 1280px) {
    font-size: 0.95rem; 
  }
  @media (max-width: 768px) {
    font-size: 0.9rem; 
    line-height: 18px;

  }

  @media (max-width: 480px) {
    font-size: 0.85rem;
    line-height: 15px;
  }

  @media (max-width: 375px) {
    font-size: 0.8rem;
  }
`;

export const StyledLink = styled('a')`
  color: #8573C1;
  font-family: Radikal;
  font-size: 1.5rem;//24px
  line-height: 2;
  cursor: pointer;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem; 
  border-bottom: 0.1vw solid #000;
  @media (max-width: 1280px) {
    font-size: 1.4rem;
  }

  @media (max-width: 1024px) {
    font-size: 1rem;
  }
  @media (max-width: 768px) {
    font-size: 1.2rem;
  }

  @media (max-width: 480px) {
    font-size: 1.1rem; 
  }

  @media (max-width: 375px) {
    font-size:0.938rem ;//15px
  }
`;

export const ContactUsButton = styled("button")`
  position: fixed;
  right: 0;
  top: 40%;
  transform: translateY(-50%);
  background-color: #1D00C4;
  color: #FFF;
  font-family: Radikal;
  font-size:1.377rem;// 22.04px
  font-weight: 500;
  padding: 2vw 1vw;
  border: none;
  border-radius: 20px 0 0 20px; 
  cursor: pointer;
  writing-mode: vertical-rl; 
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000; 
  box-shadow: -2px 0px 5px rgba(0, 0, 0, 0.2);
  
  img {
    width: 2vw; 
    height: auto;
    margin-top: 0.9vw;
  }
  @media (max-width: 1280px) {
    font-size: 1rem; 
    padding: 1.5vw 1vw;
  }
  @media (max-width: 768px) {
    font-size: 1rem; 
    padding: 5vw 2vw 4vw 3vw; 
    top: 30%;
    img {
      width: 5vw; 
      margin-top:2.5vw; 
    }
  }
`;



// ClientSpotLight.js

export const ClientSpotlightContainer = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding:3.5vw 5vw;//34px
  margin: 0 auto;
  background-color: #d7dadb;
  position: relative;
  @media (max-width: 768px) {
    padding:6vw 8vw;
}
`;

export const ClientSpotlightTitleContainer = styled("h2")`
  font-size: 1.5rem;//24px
  font-family: Radikal;
  font-weight: 500;
  color: #414042;
  text-align: center;
  margin-bottom: 2vw;

  @media (max-width: 1280px) {
  }

  @media (max-width: 1024px) {
  }

  @media (max-width: 960px) {
  }

  @media (max-width: 768px) {
    font-size:1rem;/*16px */
    margin-bottom: 4vw;
  }
`;

export const ClientSpotlightSliderContainer = styled("div")`
  width: 100%;
  margin-bottom: 3vw;
  position: relative;
`;

export const ClientSpotlightSliderImage = styled("div")`
  width: 95%;
  margin: 0 0.5vw;
  display: block;
  height: 10vw;  /*120px */
  background-color: #f0f0f0;  
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  background-color: #fff;
  position: relative;
  @media (max-width: 768px) {
    height:16vw;
  }
`;

export const IconContainer = styled("div")`
  width: 100%; 
  height: 100%; 
  background-color: #FFFFFF; 
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 0.5vw;
`;

export const ClientIcon = styled("img")`
  max-width: 95%; 
  max-height: 95%;
  object-fit: contain;
`;


export const ClientSpotlightCustomArrow = styled("img")`
  width: 20px;
  height: 30px;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
`;

export const ClientSpotlightPrevArrowStyled = styled(ClientSpotlightCustomArrow)`
  left: -20px;
`;

export const ClientSpotlightNextArrowStyled = styled(ClientSpotlightCustomArrow)`
  right: -20px;
`;

export const ClientSpotlightVideoSection = styled("div")`
  display: flex;
  justify-content: flex-start !important;
  align-items: flex-start;
  gap: 3vw;
  width: 100%;
  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

export const ClientSpotlightVideoBox = styled("div")`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ClientSpotlightVideoThumbnailImg = styled("img")`
  width: 100%;
  height: auto;
  border-radius: 10px;
`;

export const ClientSpotlightPlayButton = styled("div")`
  position: absolute;
  width: 50px;
  height: 50px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export const ClientSpotlightRightSection = styled("div")`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  @media (max-width: 768px) {
    width: 100%;
    align-items: center;
  }
`;

export const ClientSpotlightTitle = styled("span")`
  color: #414042;
  font-family: Radikal;
  font-size: 2.625rem;//42px
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 1vw;

  @media (max-width: 1366px) {
    font-size: 2.4rem;
  }

  @media (max-width: 1280px) {
    font-size: 2.2rem;
  }

  @media (max-width: 1024px) {
    font-size: 2rem;
  }

  @media (max-width: 768px) {
    font-size: 1.6rem; 
    margin-top: 5vw;
    margin-bottom: 5vw;
  }
`;

export const ClientSpotlightSubTitle = styled("span")`
  color: #231f20;
  font-family: Radikal;
  font-size: 1.313rem;//21px
  font-style: normal;
  font-weight: 600;
  margin-bottom: 1vw;

  @media (max-width: 1366px) {
    font-size: 1.2rem;
  }

  @media (max-width: 1280px) {
    font-size: 1.1rem; 
  }

  @media (max-width: 1024px) {
    font-size: 1rem;
  }
  @media (max-width: 768px) {
    font-size: 0.9rem;
    margin-bottom: 3vw;
  }
  @media (max-width: 375px) {
    font-size: 0.8rem;
  }
`;

export const ClientSpotlightDescription = styled("span")`
  font-size: 1.125rem;//18px
  color: #231f20;
  font-family: Radikal;
  font-weight: 400;
  line-height: 1.5;

  @media (max-width: 1366px) {
    font-size: 0.95rem;
  }

  @media (max-width: 1280px) {
    font-size: 0.9rem;
  }

  @media (max-width: 1024px) {
    font-size: 0.85rem;
  }

  @media (max-width: 960px) {
    font-size: 0.8rem;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
    text-align: center;
  }
  @media (max-width: 375px) {
    font-size: 0.75rem;
  }
`;

// DeeperInsightsStyles.js

export const DeeperInsightsSectionContainer = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 5vw;
  background-color: #f5f5f5;

  @media (max-width: 768px) {
    padding: 10vw auto 6vw ;  
  }
`;

export const DeeperInsightsImageWrapper = styled("div")`
  width: 60vw;
  height: auto;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2vw;

  @media (max-width: 768px) {
    width: 85vw; 
    margin-bottom: 2vw;  
  }
`;

export const DeeperInsightsHeading = styled("h2")`
  font-size:2.625rem;//42px
  font-family: Radikal;
  font-weight: 500;
  font-family: Radikal;
  color: #414042;
  margin: 1.5vw auto;
  @media (max-width: 768px) {
    margin: 4vw auto;
    font-size: 1.5rem; 
  }
`;

export const DeeperInsightsDescription = styled("p")`
  font-size: 1.125rem;//18px
  font-family: Radikal;
  max-width: 60vw;
  color: #231F20;
  font-weight: 400;
  margin-bottom: 2vw;
  @media (max-width: 768px) {
    font-size: 0.813rem;  //13px
    max-width: 90vw;  
    margin-bottom: 3vw; 
  }
`;

export const DeeperInsightsButtonWrapper = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    margin-bottom: 4vw; 
  }
`;

export const DeeperInsightsDesktopImage = styled("img")`
  display: block;
  width: 100%;
  height: auto;

  @media (max-width: 768px) {
    display: none;  
  }
`;

export const DeeperInsightsMobileImage = styled("img")`
  display: none;
  width: 100%;
  height: auto;

  @media (max-width: 768px) {
    display: block;  
  }
`;



//DepartmentCards

export const DeptCardContainer = styled("div")`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4vw;
  padding: 2.778vw 8vw;/*40px 129px */
  background-color: #D3D7FF;
  margin: 0 auto;

  @media (max-width: 1280px) {
    padding: 5vw;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const DeptMobileCardContainer = styled(Slider)`
  display: none;
  background-color: #D3D7FF;
  padding: 10vw 15vw;

  @media (max-width: 768px) {
    display: block;
    margin: 0 auto;

    .slick-slide {
      display: flex !important;
      justify-content: center;
      margin-right: 2vw; 
    }

    .slick-list {
      margin: 0 -2vw; 
    }

    .slick-track {
      display: flex;
      gap: 2vw; 
    }
  }
`;

export const DeptCard = styled("div")`
  background: white;
  padding: 3vw 3vw;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 100%;  
  transition: transform 0.3s ease, box-shadow 0.3s ease; 

&:hover {
  transform: scale(1.05); 
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.2); 
}

  @media (max-width: 768px) {
    min-height: 100vw; 
    max-height: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 5vw;
  }
`;

export const DeptCardHeader = styled("div")`
  display: flex;
  align-items: center;
  gap: 1vw;
  font-weight: 500;
  color: #414042;
  font-family: Radikal;
  align-items: flex-end;
  font-size: 1.5rem; /* 24px */

  @media (max-width: 768px) {
    font-size: 6vw; 
    gap: 3vw;
    margin-bottom: 3vw;
  }
`;

export const DeptIcon = styled("img")`
  width: 4vw;
  height: auto;

  @media (max-width: 768px) {
    width: 12vw;
  }
`;

export const DeptDescription = styled("p")`
  color: #231F20;
  font-family: Radikal;
  font-size: 0.938rem; /* 15px */
  font-weight: 400;
  margin: 1vw 0;
  flex-grow: 1;

  @media (max-width: 768px) {
    word-wrap: break-word; 
  }
`;

export const DeptFeatureDivider = styled("hr")`
  border: none;
  height: 1.5px;
  background: #ccc;
  margin: 1vw 0;

  @media (max-width: 768px) {
    margin: 2vw 0;
  }
`;

export const DeptFeatureTitle = styled("h3")`
  color: #414042;
  font-family: Radikal;
  font-size: 1.313rem; /* 21px */
  font-weight: 400;
  margin-bottom: 0.5vw;

  @media (max-width: 768px) {}
`;

export const DeptFeatureList = styled("ul")`
  list-style: none;
  padding: 0;
`;

export const DeptFeatureItem = styled("li")`
  display: flex;
  align-items: center;
  gap: 0.8vw;
  color: #231F20;
  font-family: Radikal;
  font-size: 0.938rem; /* 15px */
  font-weight: 400;
  margin: 1vw auto 1vw;

  @media (max-width: 768px) {
    margin: 2vw auto 2vw;
  }
`;

export const DeptFeatureIcon = styled("img")`
  width: 1.2vw;
  height: auto;

  @media (max-width: 768px) {
    width: 4vw; 
  }
`;

export const DeptButtonWrapper = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 1vw;
`;

export const DeptArrowButton = styled("img")`
  width: 4vw;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 2;
`;



//supportCards
export const SupportCardsContainer = styled("div")`
  display: flex;
  padding: 4vw 8vw;
  flex-wrap: wrap;
  justify-content: center;
  background-color: #D3D7FF;
  margin: 0 auto;

  @media (max-width: 1280px) {
    padding: 5vw;
  }
  @media (max-width: 768px) {
    padding: 5vw 2vw;
  }
`;

export const SupportCard = styled("div")`
  background-color: #FFFFFF;
  padding: 20px;
  border-radius: 10px;
  width: 30%;
  height: 276px; 
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

&:hover {
  transform: scale(1.05); 
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.2);
}

  @media (max-width: 1024px) {
    width: 32%; 
  }
  @media (max-width: 768px) {
    width: 45%;
    height: 220px; 
    padding: 19px 13px; 
  }
  @media (max-width: 480px) {
    width: 90%;
    height: 200px;
  }
`;

export const SupportCardImg = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid #000;
  width: 100%;
  padding-bottom: 10px; 
  text-align: center;
`;

export const SupportImage = styled("img")`
  margin: 0 auto;
  height: 50px; 
  object-fit: contain;

  @media (max-width: 768px) {
    height: 40px;
  }
`;

export const SupportTitle = styled("span")`
  font-family: Radikal;
  font-size: 1.5rem; /* 24px */
  font-weight: 500;
  text-align: center;
  color: #1D00C4;
  margin: 15px auto;

  @media (max-width: 768px) {
    font-size: 1.125rem; /* 18px */
    margin: 10px auto;
  }
`;

export const SupportDescription = styled("p")`
  max-width: 90%;
  font-family: Radikal;
  font-size: 0.938rem; /* 15px */
  font-weight: 400;
  text-align: center;
  margin: auto;

  @media (max-width: 768px) {
    font-size: 0.813rem; /* 13px */
    line-height: 16px;
  }
`;

export const CenteredTitleSubtitleContainer = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin:1vw auto;
  @media (max-width: 768px) {
    margin:2vw auto;
  }
`;

export const SupportTitleContainer = styled("h2")`
  color: #414042;
  font-family: Radikal;
  font-weight: 500;
  font-size: 2.625rem;//42px
  text-align: center; 
  padding-bottom:1rem;
  @media (max-width: 768px) {
    font-size: 1.313rem;//21px
  }
`;

export const SupportSubtitle = styled("p")`
 color: #231F20;
 text-align: center;
 font-family: Radikal;
 font-weight: 400;
 font-size: 1.125rem;//18px
  margin: 1vw auto;
  max-width: 80%;
  text-align: center;
  
  @media (max-width: 768px) {
    font-size: 0.813rem;//13px
  
  }
`;





// Solutions

export const SolutionsContainer = styled("div")`
  text-align: center;
  padding: 4.236vw; //61px
  background-color: #ffffff;
  &.solutions-container {}
  @media (max-width: 768px) {
    padding: 6vw;
  }
`;

export const SolutionsTitle = styled("span")`
  font-size: 2.625rem; //42px;
  font-weight: 500;
  color: #414042;
  font-family: Radikal;
  @media (max-width: 768px) {
    font-size: 1.313rem; // 21px;
  }
  &.solutions-title {}
`;

export const SolutionsSubtitle = styled("p")`
  color: #4a4a4a;
  font-size: 15px;
  font-family: Radikal;
  margin: 1vw auto;
  max-width: 80%;
  @media (max-width: 768px) {
    font-size: 3vw;
    max-width: 90%;
    margin-top:3vw;
  }
  &.solutions-subtitle {}
`;

export const SolutionsCardsContainer = styled("div")`
  display: flex;
  justify-content: center;
  gap: 2vw;
  margin-top: 3vw;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 6vw;
  }
  &.solutions-cards-container {}
`;

export const SolutionCard = styled("div")`
  width: 30%;
  background: white;
  border-radius: 10px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  padding-bottom: 1vw;
  position: relative;
  overflow: visible;
  transition: transform 0.3s ease, box-shadow 0.3s ease; 

&:hover {
  transform: scale(1.05); 
  box-shadow: 0px 6px 20px rgba(0, 0, 0, 0.2); 
}

  @media (max-width: 768px) {
    width: 90%;
    height: auto;
    margin:2vw auto;
  }
`;


export const SolutionCardImageWrapper = styled("img")`
  width: 100%; 
  ${'' /* height: 100%; */}
  object-fit: cover; 
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  @media (max-width: 768px) {
    height: 30vh; 
    object-fit: cover; 
  }

  @media (max-width: 320px) {
    height: 25vh; 
  }
`;
export const SolutionCardTitle = styled("h3")`
  font-size: 1.500rem; /*24px*/
  font-family: Radikal;
  font-weight: 500;
  color: #1d00c4;
  margin: 2vw 0;

  @media (max-width: 768px) {
    font-size: 1.250rem; //20px;
  }
`;

export const SolutionCardSubtitle = styled("p")`
  font-family: Radikal;
  font-size: 0.938rem; //15px;
  color: #3d2e92;
  font-weight: bold;
  margin-bottom: 2vw;

  @media (max-width: 768px) {
    font-size: 0.938rem; //15px;
    margin-bottom: 3vw;
  }
`;

export const SolutionCardDescriptionWrapper = styled("div")`
  width: 90%;
  height: 3vw;
  overflow-y: auto;
  position: relative;
  text-align: center;
  padding-right: 0.5vw;
  margin-bottom: 3vw;
  &::-webkit-scrollbar {
    width: 0.4vw;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #999;
  }

  @media (max-width: 768px) {
    margin-bottom: 10vw;
    height: 15vw !important;
    &::-webkit-scrollbar {
      width: 0.8vw;
    }
  }
  @media (max-width: 320px) {
    margin-bottom: 15vw;
    height: 18vw !important;
    &::-webkit-scrollbar {
      width: 1vw;
    }
  }
  &.solution-card-description-wrapper {}
`;

export const SolutionCardDescription = styled("p")`
  color: #231F20;
  font-weight: 500;
  text-align: center;
  font-family: Radikal;
  font-size: 15px;
  color: #231f20;
  text-align: center;
  padding: 0 1.5vw;
  @media (max-width: 768px) {
    font-size: 0.813rem; //13px;
  }
  &.solution-card-description {}
`;

export const SolutionCardButtonWrapper = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: -1.5vw;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;

  @media (max-width: 768px) {
    bottom: -3vw;
  }
  &.solution-card-button-wrapper {}
`;



// ProblemSolution

export const ProblemSolutionParentContainer = styled("div")`
  background-color: #ECEAEA;
  padding: 5vw 7vw 5vw 5vw;/* 92px 178px 96px 120px*/ 
  @media (max-width: 768px) {
    padding: 6vw 8vw;
  }
`;


export const ProblemSolutionSectionTitle = styled("h1")`
  font-size: 2.625rem; /* 42px */
  font-family: Radikal;
  font-weight: 500;
  color: #414042;
  margin-bottom: 2vw;
  text-align: left;

  @media (max-width: 768px) {
    font-size: 1.313rem; /* 21px */
    text-align: center;
  }
`;




export const ProblemSolutionContainer = styled("div")`
  display: flex;
  align-items: flex-start; 
  justify-content: flex-start;
  gap: 5vw;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center; 
    justify-content: center;
    gap: 3vw; 
  }
`;

export const ProblemSolutionVideoThumbnailContainer = styled("div")`
  position: relative; 
`;

export const ProblemSolutionPlayButton = styled("div")`
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.8);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
export const ProblemSolutionVideoContainer = styled("div")`
  width: 50%;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  @media (max-width: 768px) {
    width: 100%;
    margin-bottom: 3vw;
  }
`;

export const ProblemSolutionVideoThumbnailImg = styled("img")`
  width: 100%;
  height: auto;
  border-radius: 10px;
`;

export const ProblemSolutionContentContainer = styled("div")`
  width: 45%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;

  @media (max-width: 768px) {
    width: 100%;
    align-items: center; 
  }
`;

export const ProblemSolutionTitle = styled("span")`
  font-size: 2.625rem; /* 42px */
  font-family: Radikal;
  font-weight: 500;
  color: #414042;
  margin-bottom: 1vw;
  @media (max-width: 768px) {
    font-size: 1.125rem; /* 18px */
    text-align: center;
  }
`;

export const ProblemSolutionDescription = styled("p")`
  font-size: 1.125rem; /* 18px */
  font-family: Radikal;
  font-weight: 400;
  color:#231F20;
  line-height: 24px;
  margin-bottom: 2vw;

  @media (max-width: 768px) {
    font-size: 0.813rem; /* 13px */
    text-align: center;
  }
`;